import styled from "styled-components";

export const Container = styled.div`
  height: 84%;
  width: 100%;
  position: fixed;
  display: flex;
  align-items: center;
  justify-content: center;
  bottom: 0;
  background: rgba(255, 255, 255, 0.72);
  border-radius: 10.39px;
  color: #011f59;
  opacity: 1;
  z-index: 1;
`;

export const Link = styled.span`
  color: #5776ff;
  font-weight: bold;
  text-decoration: underline;
  cursor: pointer;
`;

export const LoadText = styled.div`
  font-size: 2vmax;
  width: fit-content;
  display: flex;
  align-items: center;
  justify-content: space-between;
  position: fixed;
  bottom: 8%;
`;
